import MinimalRegisterForm from './MinimalRegisterForm';

export default MinimalRegisterForm;

